import {
  notEmptyString,
} from '@populateui/utils';
import {
  PCCDashboardAlertDTO,
  PCCDashboardServiceDTO,
  PCCPatientDashboardRowDTO,
} from 'dtos';
import {
  PCCProgram,
} from 'dtos/pCCProgram';
import {
  PCCOverviewRow,
} from 'pages/Dashboard/pages/Dashboard/PCCOverview/types';

function getPatientRowKey(patientId?: number): string {
  return `${patientId ?? 'unknown'}`;
}

export type NormalizedPCCAlert = {
  alert: PCCDashboardAlertDTO;
  key: string;
};

export function normalizeAlerts(
  alerts?: PCCDashboardAlertDTO[] | null,
): NormalizedPCCAlert[] {
  return (alerts ?? [])
    .filter((alert) => notEmptyString(alert.label))
    .map((alert) => ({
      alert,
      key: [
        alert.type ?? '',
        alert.label ?? '',
        alert.text ?? '',
        alert.subtext ?? '',
      ].join(':'),
    }));
}

export function isEligibleToEnroll({
  isEligible = false,
  isEnrolled = false,
  isOptedOut = false,
}: PCCDashboardServiceDTO): boolean {
  return isEligible && !isEnrolled && !isOptedOut;
}

export function getEligiblePCCPrograms(
  row: PCCPatientDashboardRowDTO,
): PCCProgram[] {
  return [
    ...(isEligibleToEnroll(row.ccm ?? {}) ? [PCCProgram.CCM] : []),
    ...(isEligibleToEnroll(row.rtm ?? {}) ? [PCCProgram.RTM] : []),
    ...(isEligibleToEnroll(row.tempo ?? {}) ? [PCCProgram.Tempo] : []),
  ];
}

export function normalizePCCOverviewRows(
  rows: PCCPatientDashboardRowDTO[],
): PCCOverviewRow[] {
  return rows.map((row) => ({
    ...row,
    rowKey: getPatientRowKey(row.patient?.patientId),
  }));
}
